export function a_Color(feature) {
  var color = feature.color;
  return !color || !color.length ? [1, 1, 1, 1] : color;
}
export function a_Position(feature, featureIdx, vertex) {
  return vertex.length === 2 ? [vertex[0], vertex[1], 0] : [vertex[0], vertex[1], vertex[2]];
}
export function a_filter(feature) {
  var filter = feature.filter;
  return filter ? [1] : [0];
}
export function a_vertexId(feature, featureIdx) {
  return [featureIdx];
}